export const Types = {
    GET_TASKS_PAGE_AML: "GET_TASKS_PAGE_AML",
    GET_POOL_LIST: "GET_POOL_LIST",
    GET_STATUS_LIST: "GET_STATUS_LIST",
    GET_AUTONOMOUS_MAINTATENANCE_LIST: "GET_AUTONOMOUS_MAINTATENANCE_LIST",
    GET_TECHNICIAN_LIST: "GET_TECHNICIAN_LIST",
    GET_COST_CENTER_LIST: "GET_COST_CENTER_LIST",
    GET_AREA_LIST_AUTONOMOUS: "GET_AREA_LIST_AUTONOMOUS",
    GET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS: "GET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS",
    GET_SUB_LIST_BY_AREA_ID_AUTONOMOUS: "GET_SUB_LIST_BY_AREA_ID_AUTONOMOUS",
    SET_TASKS_PAGE_AML: "SET_TASKS_PAGE_AML",
    SET_STATUS_LIST: "SET_STATUS_LIST",
    SET_POOL_LIST: "SET_POOL_LIST",
    SET_AUTONOMOUS_MAINTATENANCE_LIST: "SET_AUTONOMOUS_MAINTATENANCE_LIST",
    SET_TECHNICIAN_LIST: "SET_TECHNICIAN_LIST",
    SET_COST_CENTER_LIST: "SET_COST_CENTER_LIST",
    SET_AREA_LIST_AUTONOMOUS: "SET_AREA_LIST_AUTONOMOUS",
    SET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS: "SET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS",
    SET_SUB_LIST_BY_AREA_ID_AUTONOMOUS: "SET_SUB_LIST_BY_AREA_ID_AUTONOMOUS",
    SHOW_SNACK_MESSAGE: "SHOW_SNACK_MESSAGE",
};

export const getTaskList = (payload) => ({
    type: Types.GET_TASKS_PAGE_AML,
    payload,
});

export const getList = () => ({
    type: Types.GET_POOL_LIST,
});

export const getStatusList = () => ({
    type: Types.GET_STATUS_LIST,
});

export const showSnackMessage = (payload) => ({
    type: Types.SHOW_SNACK_MESSAGE,
    payload,
});

export const getautonomousMaintenance = (payload) => ({
    type: Types.GET_AUTONOMOUS_MAINTATENANCE_LIST,
    payload,
});

export const getTechnicianList = (payload) => ({
    type: Types.GET_TECHNICIAN_LIST,
    payload,
});

export const getCostCenterList = (payload) => ({
    type: Types.GET_COST_CENTER_LIST,
    payload,
});

export const getAreaListAutonomous = () => ({
    type: Types.GET_AREA_LIST_AUTONOMOUS,
});

export const getMainListByAreaIDAutonomous = (payload) => ({
    type: Types.GET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS,
    payload,
});

export const getSubListByIdAutonomous = (payload) => ({
    type: Types.GET_SUB_LIST_BY_AREA_ID_AUTONOMOUS,
    payload,
});

export const setList = (payload) => ({
    type: Types.SET_POOL_LIST,
    payload,
});

export const setTaskList = (payload) => ({
    type: Types.SET_TASKS_PAGE_AML,
    payload,
});

export const setStatusList = (payload) => ({
    type: Types.SET_STATUS_LIST,
    payload,
});

export const setautonomousMaintenance = (payload) => ({
    type: Types.SET_AUTONOMOUS_MAINTATENANCE_LIST,
    payload,
});

export const setTechnicianList = (payload) => ({
    type: Types.SET_TECHNICIAN_LIST,
    payload,
});

export const setCostCenterList = (payload) => ({
    type: Types.SET_COST_CENTER_LIST,
    payload,
});

export const setAreaListAutonomous = (payload) => ({
    type: Types.SET_AREA_LIST_AUTONOMOUS,
    payload,
});

export const setMainListByAreaIDAutonomous = (payload) => ({
    type: Types.SET_MAIN_LIST_BY_AREA_ID_AUTONOMOUS,
    payload,
});

export const setSubListByIdAutonomous = (payload) => ({
    type: Types.SET_SUB_LIST_BY_AREA_ID_AUTONOMOUS,
    payload,
});
